
import { storage } from '../lib/storage';
import { FlashSale, Product } from '../types';

export const flashSaleService = {
  getStoreFlashSales: (storeId: string): FlashSale[] => {
    const data = localStorage.getItem('lynqar_flash_sales');
    const all: FlashSale[] = data ? JSON.parse(data) : [];
    return all.filter(s => s.storeId === storeId);
  },

  getActiveSale: (storeId: string): FlashSale | null => {
    const sales = flashSaleService.getStoreFlashSales(storeId);
    const now = new Date();
    return sales.find(s => {
      const start = new Date(s.startTime);
      const end = new Date(s.endTime);
      return now >= start && now <= end;
    }) || null;
  },

  createSale: (data: Omit<FlashSale, 'id'>) => {
    const allData = localStorage.getItem('lynqar_flash_sales');
    const all: FlashSale[] = allData ? JSON.parse(allData) : [];
    const newSale: FlashSale = { ...data, id: 'sale-' + Date.now() };
    all.push(newSale);
    localStorage.setItem('lynqar_flash_sales', JSON.stringify(all));
    return newSale;
  },

  deleteSale: (id: string) => {
    const allData = localStorage.getItem('lynqar_flash_sales');
    if (!allData) return;
    const all: FlashSale[] = JSON.parse(allData);
    const filtered = all.filter(s => s.id !== id);
    localStorage.setItem('lynqar_flash_sales', JSON.stringify(filtered));
  },

  getProductDiscountedPrice: (product: Product, sale: FlashSale | null): number => {
    if (!sale || !sale.productIds.includes(product.id)) return product.price;
    return product.price * (1 - sale.discountPercentage / 100);
  }
};
